export default "__VITE_ASSET__ae83cb19__"